import { Injectable, inject, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import { LicenseSwActionTypes, LicenseSwActions } from '../actions/license-sw.actions';
import {LicenseMgtService} from '../../../services/license-mgt.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import {updateInfoType} from '../../../shareModel';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {TranslateService} from '@ngx-translate/core';
import { LicenseSw } from '../license-mgt.model';

@Injectable()
export class LicenseSwEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private licenseMgtService = inject(LicenseMgtService);
  private injector = inject(Injector);

  constructor() {}

  GetLicenseSwList$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseSwActionTypes.GetLicenseSwList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const params = {
        otp: user.otp,
        Product: 'PowerPanelBusiness'
      };
      return this.licenseMgtService.ReadSWLicenseList(params).pipe(
        map((res) => {
          if (res.result && Array.isArray(res.msg.body)) {
            return new featureActions.LoadLicenseSwList({licenseSws: res.msg.body});
          } else {
            return new featureActions.GetLicenseSwListFail();
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return of(new featureActions.GetLicenseSwListFail());
        })
      );
    })
  ));
  GetLicenseSw$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseSwActionTypes.GetLicenseSw),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = {
        otp: user.otp,
        Id: action.payload.Id
      };
      return this.licenseMgtService.ReadSWLicenseList(params).pipe(
        map((res) => {
          if (res.result && Array.isArray(res.msg.body)) {
            return new featureActions.LoadLicenseSwList(res.msg.body);
          } else {
            return new featureActions.GetLicenseSwListFail();
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return of(new featureActions.GetLicenseSwListFail());
        })
      );
    })
  ));
  GetLicenseSwType$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseSwActionTypes.GetLicenseSwType),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const params = {
        otp: user.otp,
        Product: 'PowerPanelBusiness'
      };
      return this.licenseMgtService.ReadSWLicenseType(params).pipe(
        map((res) => {
          if (res.result && Array.isArray(res.msg.body)) {
            return new featureActions.LoadLicenseSwType({licenseSwTypes: res.msg.body});
          } else {
            return new featureActions.GetLicenseSwTypeFail();
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return of(new featureActions.GetLicenseSwTypeFail());
        })
      );
    })
  ));
  GetAddLicenseSw$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseSwActionTypes.GetAddLicenseSw),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = {
        otp: user.otp,
        PlanName: action.payload.licenseSw.PlanName,
        EmailInfo: action.payload.licenseSw.EmailInfo,
        UserName: action.payload.licenseSw.CustomerName,
        Note: action.payload.licenseSw.Note
      };
      return this.licenseMgtService.AddSWLicense(params).pipe(
        switchMap((res: any) => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.AddLicenseSw
          };
          if (res.result) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Update Success') })];
          } else {
            return [new featureActions.GetAddLicenseSwFail(), new featureActions.UpdateInfoFailAction(updateRes)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError((error) => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.AddLicenseSw
          };
          return [(new featureActions.GetAddLicenseSwFail()), new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  GetUpdateLicenseSw$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseSwActionTypes.GetUpdateLicenseSw),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = {
        otp: user.otp,
        Product: 'PowerPanelBusiness',
        Id: action.payload.licenseSw.Id,
        Plan: action.payload.licenseSw.PlanName,
        EmailInfo: action.payload.licenseSw.EmailInfo,
        Customer: action.payload.licenseSw.CustomerName,
        Note: action.payload.licenseSw.Note,
        WarrantyDate: action.payload.licenseSw.WarrantyDate
      };
      return this.licenseMgtService.UpdateSWLicense(params).pipe(
        switchMap((res: any) => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.EditLicenseSw
          };
          if (res.result) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Update Success') })];
          } else {
            return [new featureActions.GetUpdateLicenseSwFail(), new featureActions.UpdateInfoFailAction(updateRes)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError((error) => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.EditLicenseSw
          };
          return [(new featureActions.GetUpdateLicenseSwFail()), new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  GetDeleteLicenseSw$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseSwActionTypes.GetDeleteLicenseSw),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = {
        otp: user.otp,
        Id: action.payload.id
      };
      return this.licenseMgtService.DeleteSWLicense(params).pipe(
        switchMap((res: any) => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.EditLicenseSw
          };
          if (res.result) {
            return [new featureActions.DeleteLicenseSw({ id: action.payload.id }), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Update Success') })];
          } else {
            return [new featureActions.GetDeleteLicenseSwFail(), new featureActions.UpdateInfoFailAction(updateRes)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError((error) => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.EditLicenseSw
          };
          return [new featureActions.GetDeleteLicenseSwFail(), new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  SendLicenseSwMail$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseSwActionTypes.SendLicenseSwMail),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = {
        otp: user.otp,
        Id: action.payload.id
      };
      return this.licenseMgtService.SendSWLicenseMail(params).pipe(
        map((res: any) => {
          if (res.result) {
            const result = { ...res, type: updateInfoType.SendLicenseSwMail };
            return new featureActions.UpdateInfoSuccessAction(result);
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.SendLicenseSwMail,
          };
          return of(new featureActions.UpdateInfoFailAction(res));
        })
      );
    })
  ));
  ConfirmLicenseSw$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseSwActionTypes.GetConfirmLicenseSw),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = {
        otp: user.otp,
        LicenseKEY: action.payload.licenseKey
      };
      return this.licenseMgtService.ConfirmSWLicense(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            const result = { ...res, type: updateInfoType.ConfirmLicenseSw };
            return [new featureActions.ConfirmLicenseSw({ licenseKey: action.payload.licenseKey }),
                    new featureActions.UpdateInfoSuccessAction(result)];
          }
        }),
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.ConfirmLicenseSw,
          };
          return of(new featureActions.UpdateInfoFailAction(res));
        })
      );
    })
  ));
}
